import { FunctionComponent, memo, useMemo } from "react";
import { IProps } from "./phrase-triggers-per-day-tooltip.types";
import { FormattedDate, NumericValue } from "@edgetier/client-components";
import "./phrase-triggers-per-day-tooltip.scss";

/**
 * Tooltip component for stacked interactions chart
 * @param props.tooltipData Tooltip details coming from recharts
 * @param props.totalTriggerInteractions    Number of total interactions from triggers
 */
const PhraseTriggersPerDayTooltip: FunctionComponent<IProps> = ({ tooltipData }) => {
    // Compute total interactions for a group using tooltip data
    const totalGroupInteractions = useMemo(
        () => tooltipData.reduce((sum, payload) => sum + payload.value, 0),
        [tooltipData]
    );

    return (
        <div className="phrase-triggers-per-day-tooltip">
            <div className="phrase-triggers-per-day-tooltip__date-time">
                <FormattedDate dateTime={tooltipData[0].payload.dateTime} />
            </div>
            <div className="phrase-triggers-per-day-tooltip__total">
                <span>Total Interactions Tagged</span>
                <span>{totalGroupInteractions}</span>
            </div>
            <ul>
                {tooltipData.reverse().map(({ name, dataKey, fill, value: count }) => (
                    <li key={dataKey}>
                        <div className="phrase-triggers-per-day-tooltip__entry">
                            <div>
                                <div
                                    className="phrase-triggers-per-day-tooltip__entry__colour"
                                    style={{ backgroundColor: fill }}
                                ></div>
                                <div className="phrase-triggers-per-day-tooltip__entry__name">{name}</div>
                            </div>
                            <div>
                                <div className="phrase-triggers-per-day-tooltip__entry__value">
                                    <NumericValue value={count} /> interactions
                                </div>
                                <div className="phrase-triggers-per-day-tooltip__entry__proportion-value">
                                    (
                                    <NumericValue
                                        value={count > 0 ? (count / totalGroupInteractions) * 100 : 0}
                                        unit={count > 0 ? "%" : undefined}
                                        options={{
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        }}
                                    />
                                    )
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default memo(PhraseTriggersPerDayTooltip);
